export const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
  // Create a Uint8Array from the ArrayBuffer
  const uint8Array = new Uint8Array(buffer);

  // Convert each byte to a character and join them into a string
  const binaryString = uint8Array.reduce(
    (acc, byte) => acc + String.fromCharCode(byte),
    '',
  );

  // Encode the binary string to Base64
  return btoa(binaryString);
};
